import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "columns is-centered is-hidden-mobile" }
const _hoisted_3 = { class: "column is-5" }
const _hoisted_4 = { class: "steps" }
const _hoisted_5 = { class: "step-item is-active is-info" }
const _hoisted_6 = { class: "step-marker" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Search")
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"step-item is-info\"><div class=\"step-marker\"><span class=\"icon\"><i class=\"fa fa-circle-small\"></i></span></div><div class=\"step-details\"><p class=\"step-title\">Citations</p></div></div><div class=\"step-item\"><div class=\"step-marker\"></div><div class=\"step-details\"><p class=\"step-title\">Pay Bill</p></div></div>", 2)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-4 is-spaced" }, "Find your citation"),
    /*#__PURE__*/_createElementVNode("h2", { class: "subtitle is-6" }, "It may take up to two weeks for your ticket to be available for online payment.")
  ])
], -1)
const _hoisted_11 = { class: "columns" }
const _hoisted_12 = { class: "column" }
const _hoisted_13 = { class: "is-grey-background" }
const _hoisted_14 = { class: "columns" }
const _hoisted_15 = { class: "column is-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column is-4" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-6" }, "Search By...")
  ])
], -1)
const _hoisted_17 = {
  key: 0,
  class: "columns"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "notification is-danger" }, " Please fill out one of the following search methods below. ")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "columns"
}
const _hoisted_21 = { class: "column" }
const _hoisted_22 = { class: "notification is-danger" }
const _hoisted_23 = { class: "columns" }
const _hoisted_24 = { class: "column is-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "column is-1" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title is-6" }, "OR")
], -1)
const _hoisted_26 = { class: "column is-4" }
const _hoisted_27 = { class: "columns" }
const _hoisted_28 = { class: "column is-offset-5 is-4" }
const _hoisted_29 = { class: "columns" }
const _hoisted_30 = { class: "column is-offset-5 is-4" }
const _hoisted_31 = { class: "columns" }
const _hoisted_32 = { class: "column is-narrow" }
const _hoisted_33 = { class: "column is-narrow" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "title is-3" }, "Citation/Ticket Number"),
    /*#__PURE__*/_createElementVNode("p", null, " NOTE: If there are printed letters before the CITATION/TICKET NUMBER, you must enter them. If the CITATION/TICKET NUMBER is in a box in the upper right hand corner of the ticket and it begins with the letter \"J\" then enter all letters and numbers for the CITATION/TICKET NUMBER. Examples are JPU12345, JPV12345. If the CITATION/TICKET NUMBER is on the right hand edge of the ticket and was issued by the State Police, enter a S in front of the printed number on the ticket. Example: S1234567. If the CITATION/TICKET NUMBER is on the right hand edge of the ticket and was issued by the Causeway Police, enter a C in front of the printed number on the ticket. Example: C123456. ")
  ])
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "title is-3" }, "Case/Docket Number"),
    /*#__PURE__*/_createElementVNode("p", null, " NOTE: The CASE/DOCKET NUMBER must be preceded by the court designation letter, 'F' for First Parish Court or 'S' for Second Parish Court. Examples of CASE/DOCKET NUMBERS are: F123456, S123456. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_Form = _resolveComponent("Form")!
  const _component_o_modal = _resolveComponent("o-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_o_icon, { icon: "circle-small" })
            ]),
            _hoisted_7
          ]),
          _hoisted_8
        ])
      ])
    ]),
    _hoisted_10,
    _createVNode(_component_Form, {
      ref: "formValidator",
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Field, {
                    name: "form.LastName",
                    modelValue: _ctx.form.LastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.LastName) = $event))
                  }, {
                    default: _withCtx(({ field, meta, errors }) => [
                      _createVNode(_component_o_field, {
                        label: "Last name",
                        variant: errors[0] ? 'danger' : '',
                        message: errors[0] ? errors[0] : ''
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_input, _mergeProps({
                            placeholder: "Last name",
                            modelValue: _ctx.form.LastName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.LastName) = $event))
                          }, field), null, 16, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["variant", "message"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _hoisted_16,
              (_ctx.showSearchMethodError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                : _createCommentVNode("", true),
              (_ctx.showCaseNotFound)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.searchMessageError), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Field, { name: "TicketNumber" }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_o_field, {
                        variant: errors[0] ? 'danger' : '',
                        message: errors[0] ? errors[0] : ''
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(" Citation/ticket number "),
                          _createVNode(_component_o_icon, {
                            size: "small",
                            icon: "circle-info",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCitationHelpModalActive = true))
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_o_input, _mergeProps({
                            placeholder: "S123456",
                            modelValue: _ctx.form.TicketNumber,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.TicketNumber) = $event))
                          }, field), null, 16, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["variant", "message"])
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_Field, {
                    name: "form.DocketNumber",
                    modelValue: _ctx.form.DocketNumber,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.DocketNumber) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_o_field, {
                        variant: errors[0] ? 'danger' : '',
                        message: errors[0] ? errors[0] : ''
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(" Case/docket number "),
                          _createVNode(_component_o_icon, {
                            size: "small",
                            icon: "circle-info",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isCaseDocketHelpModalActive = true))
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_o_input, _mergeProps({
                            placeholder: "F123456 or S123456",
                            modelValue: _ctx.form.DocketNumber,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.DocketNumber) = $event))
                          }, field), null, 16, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["variant", "message"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Field, {
                    name: "form.FirstName",
                    modelValue: _ctx.form.FirstName,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.FirstName) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_o_field, {
                        label: "First name",
                        variant: errors[0] ? 'danger' : '',
                        message: errors[0] ? errors[0] : ''
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_input, _mergeProps({
                            placeholder: "First name",
                            modelValue: _ctx.form.FirstName,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.FirstName) = $event))
                          }, field), null, 16, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["variant", "message"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.form.DateOfBirth,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.DateOfBirth) = $event)),
                    name: "form.DateOfBirth"
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_o_field, {
                        label: "Date of birth",
                        variant: errors[0] ? 'danger' : '',
                        message: errors[0] ? errors[0] : ''
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_o_input, _mergeProps({
                            placeholder: "MM/DD/YYYY",
                            "data-maska": _ctx.masks.dateMask,
                            modelValue: _ctx.form.DateOfBirth,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.DateOfBirth) = $event))
                          }, field), null, 16, ["data-maska", "modelValue"]), [
                            [_directive_maska]
                          ])
                        ]),
                        _: 2
                      }, 1032, ["variant", "message"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_o_button, {
              variant: "info",
              disabled: _ctx.isSearching,
              class: "is-fullwidth-mobile",
              pack: "fas",
              "icon-left": "search",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Search")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_o_button, {
              variant: "info",
              disabled: _ctx.isSearching,
              class: "is-fullwidth-mobile",
              outlined: "",
              onClick: _ctx.clearfields
            }, {
              default: _withCtx(() => [
                _createTextVNode("Clear fields")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]),
        _createVNode(_component_o_loading, {
          "full-page": false,
          active: _ctx.isSearching,
          "onUpdate:active": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isSearching) = $event))
        }, null, 8, ["active"])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"]),
    _createVNode(_component_o_modal, {
      active: _ctx.isCitationHelpModalActive,
      "onUpdate:active": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isCitationHelpModalActive) = $event)),
      scroll: "clip"
    }, {
      default: _withCtx(() => [
        _hoisted_34
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(_component_o_modal, {
      active: _ctx.isCaseDocketHelpModalActive,
      "onUpdate:active": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isCaseDocketHelpModalActive) = $event)),
      scroll: "clip"
    }, {
      default: _withCtx(() => [
        _hoisted_35
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}